import { proxy } from 'valtio';

/**
 * 功能开关配置接口
 */
export interface FeatureFlags {
  /**
   * InMeet 页面：是否优先使用录音文件转写（而非实时转写）
   * - true: 优先使用录音文件离线转写
   * - false: 直接使用实时转写结果
   * @default true
   */
  useOfflineTranscriptionFirst: boolean;
}

/**
 * 功能开关 Store
 * 用于统一管理应用的功能开关配置
 */
export const FeatureFlagsStore = proxy<FeatureFlags>({
  useOfflineTranscriptionFirst: false,
});

/**
 * 切换"优先使用离线转写"开关
 */
export function toggleOfflineTranscriptionFirst() {
  FeatureFlagsStore.useOfflineTranscriptionFirst = !FeatureFlagsStore.useOfflineTranscriptionFirst;
  console.log('[FeatureFlags] 优先使用离线转写:', FeatureFlagsStore.useOfflineTranscriptionFirst);
}

/**
 * 设置"优先使用离线转写"开关
 */
export function setOfflineTranscriptionFirst(enabled: boolean) {
  FeatureFlagsStore.useOfflineTranscriptionFirst = enabled;
  console.log('[FeatureFlags] 设置优先使用离线转写:', enabled);
}
